import React from 'react';
import { useShiftSwapData } from './useShiftSwapData';
import { JobDetailsFragment } from '../jobDetailsComponents/graphql';
import { InfoBadge } from '@medely/ui-kit';
import { FragmentType } from '@mp/graphql/generated';

export const ShiftReleaseBadges = ({
  job,
}: {
  job?: FragmentType<typeof JobDetailsFragment> | null;
}) => {
  const {
    proHasSwapRequestToAcceptOrDecline,
    proHasSwapRequestPendingFacility,
    proDidSwapRequest,
    proAwaitingReleaseRequest,
    requestRejected,
    canShowShiftReleaseInfo,
    awaitingShiftRequestHours,
  } = useShiftSwapData({ job });

  if (!canShowShiftReleaseInfo) {
    return null;
  }

  const candidates = [
    {
      condition: proHasSwapRequestToAcceptOrDecline,
      color: 'info' as const,
      label: 'Shift swap',
    },
    {
      condition: requestRejected,
      color: 'error' as const,
      label: 'Release declined',
    },
    {
      condition: proHasSwapRequestPendingFacility,
      color: 'warning' as const,
      label: 'Pending approval',
    },
    {
      condition: proDidSwapRequest,
      color: 'warning' as const,
      label: 'Pending release',
    },
    {
      condition: proAwaitingReleaseRequest,
      color: 'warning' as const,
      label: `Release approved for ${String(awaitingShiftRequestHours)} hrs`,
    },
  ];

  const match = candidates.find((c) => c.condition);

  return match ? <InfoBadge color={match.color} label={match.label} /> : null;
};
